import React from 'react'
import { withFormik, FormikProps } from 'formik'
import { TextField, FormField, Grid, VoiceUser, TextArea } from '../../../../components'
import styles from './PortfolioDeclineForm.module.scss'

interface FormValues {
  reason: string
}

interface PortfolioDeclineFormProps {
  handleSubmit?: (values: FormValues) => void
  initialValues?: FormValues
}

const PortfolioDeclineForm: React.FC<PortfolioDeclineFormProps & FormikProps<FormValues>> = ({
  handleSubmit,
  values,
  handleChange,
  handleBlur,
}) => {
  return (
    <div className={styles.root}>
      <form onSubmit={handleSubmit}>
        <Grid>
          <Grid.Column xs={12} md={9}>
            <FormField>
              <TextField
                inputComponent={
                  <TextArea
                    name="reason"
                    placeholder="e.g. The rental amount is incorrect."
                    value={values.reason}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                }
                label="Reason for Declining"
              />
            </FormField>
          </Grid.Column>
        </Grid>

        <div className={styles.footer}>
          <VoiceUser type="submit">Decline</VoiceUser>
        </div>
      </form>
    </div>
  )
}

export default withFormik<PortfolioDeclineFormProps, FormValues>({
  enableReinitialize: true,
  mapPropsToValues: props => ({ reason: '', ...props.initialValues }),
  handleSubmit: (values, { props }) => {
    props.handleSubmit?.(values)
  },
})(PortfolioDeclineForm)
